import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cr1003',
    ecrans: ['00-2'],
    params: ['?ccecleint']
});
